import { getFileExtension } from "./Functions/GetFileExtension";

export const truncateFileName = (fileName: string, maxLength: number): string => {
    if (fileName && fileName.length > maxLength) {
        let ext = getFileExtension(fileName);
        return fileName.substring(0, maxLength - 6) + '...' + ext;
    }

    return fileName;
}